// Oferta Amazon manual (SiteStripe): regras puras da tela /sistema/amazon-manual.
// A validação de verdade é do backend (amazon_sitestripe.py); esta cópia só dá retorno imediato no formulário.

import { SITESTRIPE_RE } from '../../utils/amazonSitestripe';

export { SITESTRIPE_RE };
export const ROTA_API = '/amazon-manual';
// Mesma regra de backend/amazon_sitestripe.IMAGEM_AMAZON_RE: imagem hospedada pela Amazon não entra.
export const IMAGEM_AMAZON_RE = /(^|\.)(amazon\.[a-z.]+|media-amazon\.com|ssl-images-amazon\.com|images-amazon\.com|amazonaws\.com|link\.amazon|amzn\.to|a\.co)$/;

export const PRIME_OPCOES = [
    { valor: 'unknown', rotulo: 'Não sei' },
    { valor: 'true', rotulo: 'Sim — só para membros Prime' },
    { valor: 'false', rotulo: 'Não' },
];

export const STATUS_PEDIDO = {
    aprovada: { label: 'Aprovada — aguardando o publicador', cls: 'sv-badge-warning' },
    enfileirada: { label: 'Na fila do WhatsApp', cls: 'sv-badge-info' },
    enviada: { label: 'Publicada', cls: 'sv-badge-success' },
    recusada: { label: 'Recusada', cls: 'sv-badge-danger' },
    falhou: { label: 'Falhou', cls: 'sv-badge-danger' },
};

/** '' quando o link é um shortlink oficial do SiteStripe; senão a mensagem para o formulário. Nunca abre o link. */
export function erroLink(valor) {
    const link = String(valor || '').trim();
    if (!link) return 'Cole o link gerado no SiteStripe.';
    if (!/^https:\/\//i.test(link)) return 'O link precisa começar com https://';
    let host = '';
    try { host = new URL(link).host; } catch (_) { return 'Link inválido.'; }
    if (host !== 'link.amazon') return 'Use o link curto do SiteStripe (https://link.amazon/...).';
    if (!SITESTRIPE_RE.test(link)) return 'Formato de link do SiteStripe não reconhecido.';
    return '';
}

export function erroImagem(valor) {
    const url = String(valor || '').trim();
    if (!url) return '';
    if (!/^https:\/\/[^\s"'<>]+$/i.test(url)) return 'A imagem precisa ser uma URL https.';
    let host = '';
    try { host = new URL(url).hostname.toLowerCase(); } catch (_) { return 'A imagem precisa ser uma URL https.'; }
    return IMAGEM_AMAZON_RE.test(host) ? 'Imagem hospedada pela Amazon não é permitida sem a API oficial. Deixe sem imagem.' : '';
}

/** Oferta da lista -> formulário de edição (a observação vem do detalhe; o atestado é pedido de novo). */
export function formDeOferta(o, nota = '') {
    return {
        title: o.title || '', affiliate_link: o.affiliate_link || '', image_url: o.image_url || '',
        category_id: o.category_id || '', campaign: o.campaign || '',
        requires_prime: o.requires_prime === true ? 'true' : o.requires_prime === false ? 'false' : 'unknown',
        note: nota || '', tracking_attested: false,
    };
}

/** Corpo do POST: nunca leva preço (a API recusa). */
export function corpoOferta(form) {
    return {
        title: String(form.title || '').trim(),
        affiliate_link: String(form.affiliate_link || '').trim(),
        image_url: String(form.image_url || '').trim(),
        category_id: form.category_id || '',
        campaign: form.campaign || '',
        requires_prime: form.requires_prime || 'unknown',
        note: String(form.note || '').trim(),
        tracking_attested: form.tracking_attested === true,
    };
}

/** AMAZON_MANUAL_SITESTRIPE_ENABLED: só com a flag ligada no backend o fluxo é utilizável (a API recusa de todo jeito). */
export function fluxoAtivo(config) {
    return Boolean(config) && config.enabled === true;
}

export function podeCadastrar(form) {
    return String(form.title || '').trim().length >= 3 && !erroLink(form.affiliate_link) && !erroImagem(form.image_url)
        && form.tracking_attested === true;
}

export function rotuloPrime(v) {
    if (v === true) return 'Sim';
    if (v === false) return 'Não';
    return 'Não sei';
}

export function dataCurta(iso) {
    if (!iso) return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}
